import { ApolloClient, InMemoryCache } from '@apollo/client';

const API_URL = import.meta.env.VITE_API_URL;

const GRAPHQL_URL = `${API_URL}/graphql`;

const client = new ApolloClient({
  uri: GRAPHQL_URL,
  cache: new InMemoryCache(),
  headers: {
    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
  },
});

export default client;
